// @ts-nocheck
import { useEffect, useMemo, type Context } from "react";
import { ApolloError, useQuery } from "@apollo/client";
import { getCachedLensListV2, type GetCachedLensListV2Query } from "../api/query";
import { usePaginationContext, type PaginationInterpreter } from "../../common/state";
import { LensListPaginationContext } from "../context";
import { LensListItemModel } from "../models";

export const useLoadLensesV2 = (preload: boolean = true) => {
    const paginationContext = usePaginationContext(LensListPaginationContext as Context<PaginationInterpreter>);

    const { firstLoad } = paginationContext;

    const { data, error: getCachedLensListV2Error } = useQuery<GetCachedLensListV2Query>(getCachedLensListV2, {
        fetchPolicy: "cache-only",
    });

    useEffect(() => {
        if (preload) {
            firstLoad();
        }
    }, [firstLoad, preload]);

    const lenses = useMemo(
        () => data?.getLensListV2!.lensesWithConnections!.map(LensListItemModel.createFromLensWithConnections) || [],
        [data],
    );

    const paginationContextError = paginationContext.error ? new ApolloError(paginationContext.error) : null;

    return {
        ...paginationContext,
        lenses,
        error: paginationContextError || getCachedLensListV2Error,
    };
};
